/**
 * Move History rows and Asset filter (AST-119).
 *
 * On manually counted projects the Entry Log becomes Move History, and its
 * Mat Type column + filter become Asset, showing manual asset names (ST124).
 * Pure, so the naming and filtering rules are tested without rendering.
 *
 *   MH-3  a move's Asset is its manual asset's name
 *   MH-4  a move saved before manual assets existed shows its subtype name
 *         (Timber Mat), so history stays complete
 *   MH-5  filter options: the customer's manual asset names, one flat list
 *         A->Z, archived INCLUDED so past moves can still be found
 *   MH-6  filtering by a manual asset shows only moves recorded against it --
 *         by id, so a subtype-only move (or another asset of the same
 *         subtype) never sneaks in
 *   MH-7  names are looked up live by id, so a rename shows its new name on
 *         every past move
 */

const natural = (a, b) => a.localeCompare(b, undefined, { numeric: true, sensitivity: 'base' });

/**
 * Display name for one move's Asset cell.
 * assetById: { [id]: { name, archived } } -- archived included.
 * subtypeNameById: { [subtypeId]: name }.
 */
export function assetLabel(entry, assetById, subtypeNameById) {
  const asset = entry?.manualAssetId ? assetById[entry.manualAssetId] : null;
  if (asset?.name) return asset.name; // MH-3, MH-7 (current name)
  // MH-4, and the fallback for an asset id we can't resolve: never blank.
  return subtypeNameById[entry?.matTypeId] || entry?.matTypeId || '—';
}

/**
 * MH-5: Asset filter options, flat A->Z by name, archived included and
 * flagged. Only the given asset type's assets (the Mat type, today) --
 * the log is a mat log.
 */
export function assetFilterOptions(manualAssets, assetTypeId) {
  return (manualAssets || [])
    .filter((a) => a?.id && a.name && (!assetTypeId || a.assetTypeId === assetTypeId))
    .map((a) => ({ id: a.id, name: a.name, archived: !!a.archived, label: a.archived ? `${a.name} (archived)` : a.name }))
    .sort((x, y) => natural(x.name, y.name));
}

/** MH-6: only moves recorded against that manual asset. */
export function filterByAsset(entries, manualAssetId) {
  if (!manualAssetId) return entries || [];
  return (entries || []).filter((e) => e.manualAssetId === manualAssetId);
}
